import React from 'react';

function formatDateTime(dateString) {
  const options = {
    timeZone: 'Asia/Karachi',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: true,
  };

  try {
    const date = new Date(dateString);
    const formattedDate = new Intl.DateTimeFormat('en-GB', options).format(date);
    return formattedDate.replace(/am|pm/i, match => match.toUpperCase());
  } catch (error) {
    console.error('Date parsing error:', error);
    return '';
  }
}

export default function DateFormatter({ date }) {
  return <div>{formatDateTime(date)}</div>;
}
